import { KYC as types } from '@store/constants';

const initialState = {
  kycs: {
    isLoading: false,
    isError: false,
    error: null,
    data: null,
    totalPages: 0
  },
  user: {
    kycDetails: {
      data: null,
      isLoading: false,
      isError: false,
      error: null
    },
    checks: {
      isLoading: false,
      isError: false,
      error: null,
      data: null,
      totalPages: 0
    },
    kycTags: {
      isLoading: false,
      isError: false,
      error: null,
      data: null,
      totalPages: 0
    },
    kycTiers: {
      data: null,
      isLoading: false,
      isError: false,
      error: null
    }
  }
};

const kycReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.GETTING_KYC_DETAILS:
      return {
        ...state,
        user: {
          ...state.user,
          kycDetails: {
            ...state.user.kycDetails,
            data: null,
            isLoading: true,
            isError: false,
            error: null
          }
        }
      };

    case types.GET_KYC_DETAILS_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          kycDetails: {
            ...state.user.kycDetails,
            data: payload,
            isLoading: false,
            isError: false,
            error: null
          }
        }
      };

    case types.GET_KYC_DETAILS_FAILURE:
      return {
        ...state,
        user: {
          ...state.user,
          kycDetails: {
            ...state.user.kycDetails,
            data: null,
            isLoading: false,
            isError: true,
            error: payload
          }
        }
      };

    case types.CLEAR_KYC_DETAILS:
      return {
        ...state,
        user: {
          ...state.user,
          kycDetails: {
            data: null,
            isLoading: false,
            isError: false,
            error: null
          }
        }
      };

    case types.GETTING_KYC_CHECKS:
      return {
        ...state,
        user: {
          ...state.user,
          checks: {
            ...state.user.checks,
            isLoading: true,
            isError: false,
            error: null,
            data: null,
            totalPages: 0
          }
        }
      };

    case types.GET_KYC_CHECKS_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          checks: {
            ...state.user.checks,
            isLoading: false,
            isError: false,
            error: null,
            data: payload.data,
            totalPages: payload.totalPages
          }
        }
      };

    case types.GET_KYC_CHECKS_FAILURE:
      return {
        ...state,
        user: {
          ...state.user,
          checks: {
            ...state.user.checks,
            isLoading: false,
            isError: true,
            error: payload,
            data: null,
            totalPages: 0
          }
        }
      };

    case types.CLEAR_KYC_CHECKS:
      return {
        ...state,
        user: {
          ...state.user,
          checks: {
            isLoading: false,
            isError: false,
            error: null,
            data: null,
            totalPages: 0
          }
        }
      };

    case types.GETTING_ALL_KYCS:
      return {
        ...state,
        kycs: {
          ...state.kycs,
          isLoading: true,
          isError: false,
          error: null,
          data: null,
          totalPages: 0
        }
      };

    case types.GET_ALL_KYCS_SUCCESS:
      return {
        ...state,
        kycs: {
          ...state.kycs,
          isLoading: false,
          isError: false,
          error: null,
          data: payload.data,
          totalPages: payload.totalPages
        }
      };

    case types.GET_ALL_KYCS_FAILURE:
      return {
        ...state,
        kycs: {
          ...state.kycs,
          isLoading: false,
          isError: true,
          error: payload,
          data: null,
          totalPages: 0
        }
      };

    case types.CLEAR_ALL_KYCS:
      return {
        ...state,
        kycs: {
          isLoading: false,
          isError: false,
          error: null,
          data: null,
          totalPages: 0
        }
      };

    case types.SYNCING_USER_KYC:
      return {
        ...state,
        user: {
          ...state.user,
          kyc: {
            ...state.user.kyc,
            isLoading: true,
            isError: false,
            error: null,
            data: null
          }
        }
      };
    case types.SYNC_USER_KYC_SUCCESS:
      return {
        ...state,
        kycs: {
          ...state.kycs,
          isLoading: false,
          isError: false,
          error: null,
          totalPages: 0,
          data: null
        },
        user: {
          ...state.user,
          kyc: {
            ...state.user.kyc,
            isLoading: false,
            isError: false,
            error: null,
            data: payload
          }
        }
      };

    case types.SYNC_USER_KYC_FAILURE:
      return {
        ...state,
        user: {
          ...state.user,
          kyc: {
            ...state.user.kyc,
            isLoading: false,
            isError: true,
            error: payload,
            data: null
          }
        }
      };

    case types.UPDATE_CHECK_STATUS_SUCCESS:
      return {
        ...initialState
      };

    case types.CREATE_E_KYC_SUCCESS:
      return {
        ...initialState
      };

    case types.CREATE_M_KYC_SUCCESS:
      return {
        ...initialState
      };

      case types.GETTING_KYC_TAGS:
        return {
          ...state,
          kycTags: {
            isLoading: true,
            isError: false,
            error: null,
            data: null
          }
        };

      case types.GET_KYC_TAGS_SUCCESS:
        return {
          ...state,
          kycTags: {
            isLoading: false,
            isError: false,
            error: null,
            data: payload
          }
        };

      case types.GET_KYC_TAGS_FAILURE:
        return {
          ...state,
          kycTags: {
            isLoading: false,
            isError: true,
            error: payload,
            data: []
          }
        };

      case types.GETTING_KYC_TIERS:
        return {
          ...state,
          user : {
            ...state.user,
            kycTiers: {
              ...state.user.kycTiers,
              data: null,
              isLoading: true,
              isError: false,
              error: null
            }
          }
        }
      case types.GET_KYC_TIERS_SUCCESS:
        return {
          ...state,
          user : {
            ...state.user,
            kycTiers: {
              ...state.user.kycTiers,
              data: payload,
              isLoading: false,
              isError: false,
              error: null
            }
          }
        }

      case types.GET_KYC_TIERS_FAILURE:
        return {
          ...state,
          user : {
            ...state.user,
            kycTiers: {
              ...state.user.kycTiers,
              data: null,
              isLoading: false,
              isError: true,
              error: payload
            }
          }
        }

    default:
      return {
        ...state
      };
  }
};

export default kycReducer;
